import { __awaiter } from '../_virtual/_tslib.js';
import { changeModule, initOptions, options } from './core/option.js';
import { stepInit } from './core/step.js';
import { getReportTrackingLog, getLogString, startTracking } from './track/index.js';
import { indexDbHandler } from './track/indexdb.js';
import { SDK_NAME, SDK_VERSION } from './common/config.js';
import { HandleEvents } from './core/handleEvents.js';
import { reportCustomPb, _techReportPb, changeReport, _techReportPbForMiddleWare, loadPbReport } from './core/new-report.js';
import { isInBrowser } from './utils/isInBrowser.js';
import { getGlobalSupport, variableTypeDetection, mirrorStringRep } from './utils/unils.js';
import { InitMode, SIGNMANAGE, EVENTTYPES } from './utils/enum.js';
import { mirrorPluginsIns } from './core/handlePlugin.js';

var _a;
const _support = getGlobalSupport();
const INITIAL_MIRROR = '__INITIAL_MIRROR__';
const MIRROR_REPORT = '__MIRROR_REPORT__';
const MIRROR_CONFIG = '__MIRROR_CONFIG__';
// 修改模块(多用于微应用上报不同模块)
const changeMirrorModule = (val) => {
    changeModule(val);
};
// pb report
const customReportPb = (options) => {
    if (!isInBrowser())
        return;
    reportCustomPb(options);
};
// tech report
const techReportPb = (options) => {
    if (!isInBrowser())
        return;
    _techReportPb(options);
};
// 初始化or修改pb配置
const changePbOptions = (options) => {
    if (!isInBrowser())
        return;
    changeReport(options);
};
// pb方法上报pv
const pbReportPv = (msg, otherSpmId) => {
    if (!isInBrowser())
        return;
    reportCustomPb({
        type: 'pv',
        eventId: '0.0',
        msg: msg,
        otherSpmId: otherSpmId ? otherSpmId : null
    });
};
// 专属通道上报(单独ck-job-custom)
const exclusiveBisReport = (params) => {
    if (!isInBrowser())
        return;
    if (!mirrorStringRep(params.key))
        return;
    _techReportPb({
        type: 'custom',
        eventId: params.eventId,
        diyevent: true,
        msg: Object.assign(Object.assign({ exclusiveFrom: (params === null || params === void 0 ? void 0 : params.key) || '' }, params.msg), SIGNMANAGE.TECH_CUSTOM)
    });
};
// 上报所有日志,默认不上报player,传入true则上报player
const trackLogReport = (isReportPlayer = false) => {
    return getReportTrackingLog(isReportPlayer);
};
// 写入indexdb的方法
// 记录IndexDB 的格式为[time]-[type]:string,info
// 其中 time部分无需手动传入，会自动添加
// demo getLogString('electron-pc-tab', 'pc客户端弹窗切换', { tab: 'home' })===> [2021-08-25-15:00:00:000]-[electron-pc-tab]: pc客户端弹窗切换 {"tab":"home"}
const trackCustomLog = (type, info, data) => {
    getLogString(type, info, data);
};
// 获取所有web日志,返回数组形式
const trackGetLog = () => {
    return indexDbHandler.getAll(false);
};
// 入口
function init(options) {
    if (!isInBrowser())
        return;
    if (_support.isInited)
        return;
    _support.isInited = true;
    if (!_support.mirrorInitMode) {
        _support.mirrorInitMode = InitMode.DEFAULT;
    }
    // 初始化配置
    initOptions(options)
        .then(() => __awaiter(this, void 0, void 0, function* () {
        // 未命中任何采样率切无任何上报触发的情况下会丢失pv上报
        yield loadPbReport();
        // 生命周期init
        const initRes = yield mirrorPluginsIns.before(EVENTTYPES.INIT, options);
        if (!initRes)
            return;
        // 开始监控
        stepInit(options === null || options === void 0 ? void 0 : options.config);
        // 技术上报pv-可以拉取到正常业务pv下线技术pv
        // initTechPvReport()
        // 用户行为日志
        startTracking();
        // 生命周期after
        mirrorPluginsIns.after(EVENTTYPES.INIT, options);
        // log信息
        console.info('%c%s', 'line-height: 30px; color: #FF6699', `bili-fe-mirror:${SDK_VERSION}`);
    }))
        .catch(e => {
        console.warn(e);
    });
}
// vue项目
const install = function (Vue, options = {}) {
    let handler = Vue.config.errorHandler;
    Vue.config.errorHandler = function (err, vm, info) {
        HandleEvents.handleError(err);
        if (handler)
            handler.apply(null, [err, vm, info]);
        // 展示原有vue错误到控制台
        console.error(err);
    };
    init(options);
};
// 提供外部可延迟上报的方法多用于api
const canBatchTechReport = (options, config) => {
    if (!isInBrowser())
        return;
    _techReportPbForMiddleWare(options, config);
};
// 自定义指标上报
const customPerformanceQuota = (options$1) => {
    if (!isInBrowser())
        return;
    if (!mirrorStringRep(options$1.name))
        return;
    const event_id = `${options.origin}.${options.module}.PERFORMANCE.${options$1.name}`;
    _techReportPb({
        type: 'performance',
        eventId: event_id,
        msg: {
            name: options$1.name,
            value: options$1.value
        }
    });
};
// react项目在ErrorBoundary中上报错误
const errorBoundary = err => {
    HandleEvents.handleError(err);
};
// mirror技术pv上报(一般用户触发changeMirrorModule后)
const mirrorTechPvReport = (msg = {}, otherSpmId = '') => {
    // initTechPvReport(msg, otherSpmId)
};
// 防止重复挂载
function initGlobalVar(name, value) {
    if (!window[name]) {
        window[name] = value;
    }
}
if (isInBrowser()) {
    // umd 自动挂载window,防止重复挂载
    initGlobalVar(INITIAL_MIRROR, init);
    initGlobalVar(MIRROR_REPORT, {
        techReportPb,
        customReportPb,
        pbReportPv,
        changePbOptions,
        canBatchTechReport,
        customPerformanceQuota,
        exclusiveBisReport,
        changeMirrorModule,
        mirrorTechPvReport,
        trackLogReport,
        trackCustomLog,
        trackGetLog
    });
    // umd 挂载设置了配置选项,自动初始化
    if (window[MIRROR_CONFIG]) {
        if (variableTypeDetection.isObject(window[MIRROR_CONFIG])) {
            const typedOption = window[MIRROR_CONFIG];
            const isAutoInit = (_a = typedOption.config) === null || _a === void 0 ? void 0 : _a.isAutoInit;
            if (isAutoInit) {
                !_support.mirrorInitMode && (_support.mirrorInitMode = InitMode.AUTO);
                init(typedOption);
            }
        }
    }
}
var index = {
    SDK_NAME,
    SDK_VERSION,
    init,
    install,
    errorBoundary
};

export { canBatchTechReport, changeMirrorModule, changePbOptions, customPerformanceQuota, customReportPb as customReport, customReportPb, index as default, exclusiveBisReport, mirrorTechPvReport, pbReportPv, techReportPb, trackCustomLog, trackGetLog, trackLogReport };
